/*
**************************** 
홈페이지 악세사리 구매
*****************************
*/

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import PopupDom from "./PopupDom";

import { useContext } from 'react';
import { MyContext } from "../App";

export default function BuyAccesoryOrderSub(props) {
    const { choiceValue, setValue } = useContext(MyContext);

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPostCode = function () {
        setIsPopupOpen(true);
    }
    const closePostCode = function () {
        setIsPopupOpen(false);
    }
    const [address, setAddress] = useState("");
    const callBackAddress = function (address) {
        setAddress(address);
    }

    // const PAY_URL = "https://bs-l4box.com/payment"; 
    // const PAY_URL = "http://13.125.167.77/payment"; //dev
    // const PAY_URL = "http://localhost:5000/buy/payment"; //local
    const PAY_URL = "/buy/payment";
    const [userData, setUserData] = useState({ userName: "", phone: "" });
    const [proData, setProData] = useState({});

    const req = async function (userId) {
        const reqSql = "/api/users/user/" + userId;
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.data.length > 0) {
                const user = res.data[0];
                let copyUserData = {
                    ...userData, user_id: user.id, username: user.username, name: user.name, email: user.email, phone: user.phone, address: user.address, subAddress: user.sub_address, password: user.pass
                };
                setUserData(copyUserData);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");

            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        const id = choiceValue.userId;

        if (Number(id) != -1 && id != '' && id != null) {
            req(id);
        }

    }, [choiceValue]);

    useEffect(() => {
        let copyUserData = {
            ...userData, username: props.user.username, name: props.user.name, email: props.user.email, phone: props.user.phone, address: props.user.address, subAddress: props.user.sub_address, password: props.user.pass
        };
        setUserData(copyUserData);

        let copyProdata = {
            ...proData, product_id: props.data.id, product: props.data.product, price: props.data.price, delivery: props.data.delivery, discount: props.data.discount, point: props.data.point, product_key: props.data.product_key, product_type: props.data.product_type,
            use_type: props.data.use_type, content_set_id: props.data.toktok_set_type, content_use_value: props.data.content_use_value
        };
        setProData(copyProdata);
    }, [props.data]);

    const confirmService = useRef(false);
    const confirmPrivate = useRef(false);
    const confirmEventshop = useRef(false);
    const confirmOthershop = useRef(false);
    const confirmeCommerce = useRef(false);
    const confirmAge = useRef(false);

    const submitOrder = (event) => {
        event.preventDefault();

        if (event.target.product_color_eraser != null && event.target.product_color_eraser.value == "-1") {
            alert("지우개 색상을 선택해 주세요");
            return;
        }

        if (event.target.product_color_pen != null && event.target.product_color_pen.value == "-1") {
            alert("펜 색상을 선택해 주세요");
            return;
        }

        if (confirmService.current === true && confirmeCommerce.current === true) {
            const sumAddr = userData.address + " " + userData.subAddress;

            const product_color = event.target.product_color.value;

            const productDataUri = PAY_URL;
            window.open("", "openForm", "scrollbars=no, location=no, toolbar=no, menubar=no, resizable=no, titlebar=no,  copyhistory=no, width=1000, height=700");

            var datas_param = [["product_id", proData.product_id], ["user_id", userData.user_id], ["sumAddr", sumAddr], ["goodsName", proData.product],
            ["amt", choiceValue.amount + proData.delivery], ["buyerName", userData.username], ["buyerEmail", userData.email], ["buyerTel", userData.phone],
            ["confirmeCommerce", confirmeCommerce.current], ["confirmService", confirmService.current], ["confirmPrivate", confirmPrivate.current], ["confirmEventshop", confirmEventshop.current], ["confirmOthershop", confirmOthershop.current], ["confirmAge", confirmAge.current],
            ["target_userName", event.target.target_userName.value], ["target_address", event.target.target_address.value], ["target_subAddress", event.target.target_subAddress.value],
            ["target_phone", event.target.target_phone.value], ["reqOrder", event.target.reqOrder.value], ["reqReserved", proData.product_type], ["productColor", product_color], ["use_type", proData.use_type], ["product_amount", event.target.product_amount.value],
            ["content_set_id", proData.content_set_id], ["content_use_value", proData.content_use_value]
            ];

            var f = document.createElement("form"); // form 엘리멘트 생성 
            f.setAttribute("target", "openForm"); // method 속성을 post로 설정
            f.setAttribute("method", "post"); // method 속성을 post로 설정
            f.setAttribute("action", productDataUri); // submit했을 때 무슨 동작을 할 것인지 설정
            document.body.appendChild(f); // 현재 페이지에 form 엘리멘트 추가 
            for (var i = 0; i < datas_param.length; i++) {
                var data_param = datas_param[i];
                var name = data_param[0];
                var value = data_param[1];
                var it = document.createElement("input"); // input 엘리멘트 생성 
                it.setAttribute("type", "hidden"); // type 속성을 hidden으로 설정
                it.setAttribute("name", name); // name 속성을 'm_nickname'으로 설정
                it.setAttribute("value", value); // name 속성을 'm_nickname'으로 
                f.appendChild(it); // form 엘리멘트에 input 엘리멘트 추가 
            }

            f.submit(); // form 태그 서브밋 실행
        }
    }

    return (
        <div>
            <div>
                <div className="modal fade" id={props.data.product_key + "_" + props.data.id + "_sub"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold" id="exampleModalLabel">{proData.product} 구매하기</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                    window.location.href = "/BuyAccesory";
                                }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-in">
                                    <form onSubmit={submitOrder} >
                                        <div className="mt-3">
                                            <h6 className="col text-start fs-6 fw-bolder pt-2" >주문자 정보</h6>
                                        </div>
                                        <div>
                                            <h5 className="col text-start small" id="exampleModalLabel">{userData.username + " " + userData.phone}</h5>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="userName" className="form-label mt-2 small fw-bolder">이름:</label>
                                            <input type="text" className="form-control" placeholder="" name="userName" value={userData.username || ''} disabled></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="phone" className="form-label mt-2 small fw-bolder">전화번호:</label>
                                            <input type="tel" className="form-control" placeholder="" name="phone" value={userData.phone || ''} disabled></input>
                                        </div>
                                        <hr className="mt-4 mb-4"></hr>
                                        <div className="text-start">
                                            <h5 className="text-start fs-6 fw-bold " id="exampleModalLabel">배송지</h5>
                                        </div>
                                        <p className="text-start small">{userData.address + " " + userData.subAddress}</p>
                                        <div className="accordion" id="accordionExample">
                                            <div className="accordion-item">
                                                <h2 className="accordion-header" id="headingOne">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        배송지 변경
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="form-group text-start">
                                                            <label htmlFor="target_userName" className="form-label small">받는 사람:</label>
                                                            <input type="text" className="form-control" placeholder="받는 사람" name="target_userName" ></input>
                                                            <div className="form-group text-start small">
                                                                <label htmlFor="target_address" className="form-label mt-4">주소:</label><span><button type="button" className="btn btn-info small m-2" onClick={() => {
                                                                    openPostCode();
                                                                }}>우편번호 검색</button></span>
                                                                <input type="text" className="form-control" placeholder="우편번호 검색을 통해서 주소를 입력해 주세요" name="target_address" value={address || ''} disabled></input>
                                                            </div>
                                                            <div className="form-group text-start">
                                                                <label htmlFor="target_subAddress" className="form-label mt-4 small">상세 주소:</label>
                                                                <input type="text" className="form-control" placeholder="상세 주소를 입력해 주세요" name="target_subAddress" ></input>
                                                            </div>
                                                            <div className="form-group text-start">
                                                                <label htmlFor="target_phone" className="form-label mt-4 small">전화번호:</label>
                                                                <input type="tel" className="form-control" placeholder="전화번호를 입력해 주세요" name="target_phone" ></input>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group text-start">
                                                <label htmlFor="reqOrder" className="form-label mt-4 small fw-bolder">배송메세지:</label>
                                                <textarea type="text" className="form-control small" placeholder="전달할 메세지가 있으면 작성해 주세요" name="reqOrder" ></textarea>
                                            </div>
                                        </div>
                                        <hr className="mt-4 mb-2"></hr>
                                        <div className="row pt-2 mt-2">
                                            <div className="text-start mt-2 mb-2">
                                                <h5 className="text-start fs-6 fw-bold" id="exampleModalLabel">결제상세</h5>
                                            </div>
                                            <div className="col-6 text-start smal fw-bolder"><p>총 상품금액</p></div>
                                            <div className="col-6 text-end fw-bold small fw-bolder"><p>{choiceValue.amount.toLocaleString()} 원</p></div>
                                            <div className="col-6 text-start small fw-bolder"><p>배송비</p></div>
                                            <div className="col-6 text-end small fw-bolder"><p>{proData.delivery > 999 ? proData.delivery.toLocaleString() : proData.delivery} 원</p></div>
                                            <div className="col-6 text-start small fw-bolder"><p>색상</p></div>
                                            <div className="col-6 text-end small fw-bolder"><p>{choiceValue.productColor}</p></div>
                                            <input className="form-check-input" type="hidden" name="product_color" value={choiceValue.productColor} ></input>
                                            <div className="col-6 text-start small fw-bolder"><p>수량</p></div>
                                            <div className="col-6 text-end small fw-bolder"><p>{choiceValue.productAmount}</p></div>
                                            <input className="form-check-input" type="hidden" name="product_amount" value={choiceValue.productAmount} ></input>
                                        </div>
                                        <hr className="mt-2 mb-4"></hr>
                                        <div className="row">
                                            <h5 className="col-6 text-start fs-6 fw-bold" ><p>최종결제금액</p></h5>
                                            <div className="col-6 text-end fw-bold"><p>{(choiceValue.amount + proData.delivery).toLocaleString()} 원</p></div>
                                        </div>
                                        <hr></hr>
                                        <div className="form-group text-start mt-4 ">
                                            <h6><input type="checkbox" className="form-check-input small" name="l4age" required onClick={(e) => {
                                                confirmAge.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-none" href="#" >만14세 이상 입니다.</a></span></h6>
                                            <h6><input type="checkbox" className="form-check-input small" name="l4service" required onClick={(e) => {
                                                confirmService.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/d6da601eddaa4953a20daf459ba61da0" target="_blank" onClick={() => {
                                                window.open(this.href, 'l4service', 'width=430,height="400", location=no,status=no,scrollbars=yes');
                                            }}>[필수]이용약관 동의</a></span></h6>
                                            <h6><input type="checkbox" className="form-check-input small" name="l4commerce" required onClick={(e) => {
                                                confirmeCommerce.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/fde5f937e1004f0bb78c72fa9344a83e" target="_blank" onClick={() => {
                                                window.open(this.href, 'l4private', 'width=430,location=no,status=no,scrollbars=yes');
                                            }}>[필수]개인정보 수집 ・ 이용 동의</a></span></h6>
                                            <h6><input type="checkbox" className="form-check-input small " name="l4eventshop" onClick={(e) => {
                                                confirmEventshop.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom"
                                                href="https://peach-margin-2a3.notion.site/f86af813d9924dfbbe3236addb261413"
                                                target="_blank">[선택]이벤트/마케팅, 광고 정보 활용 및 수신 동의</a></span></h6>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            <input type="submit" className="btn btn-lg btn-primary" value="결제하기"></input>
                                        </div >
                                    </form>
                                    <div>
                                        {isPopupOpen === true ? <PopupDom open={true} close={closePostCode} header="우편번호 검색" onClose={closePostCode} dataCall={callBackAddress}></PopupDom> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}